var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('fuzzy-autocomplete',{attrs:{"label":_vm.label,"items":_vm.countries,"stringExtract":(x) => {
        return x;
      },"min-search-length":2,"error-messages":_vm.errorMessages,"synonyms":_vm.synonyms},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }